import React from "react"
import PropTypes from "prop-types"
import { defineMessages, useIntl } from "react-intl"
import Alert from "@material-ui/lab/Alert"
import AlertTitle from "@material-ui/lab/AlertTitle"
import { Container } from "@material-ui/core"

const errorMessage = defineMessages({
  title: {
    id: "widget.error.boundary.title",
    defaultMessage: "Erreur lors du rendu du widget ({type})"
  },
  info: {
    id: "widget.error.boundary.info",
    defaultMessage:
      "Nous ne pouvons afficher le composant graphique correctement. Une erreur est survenue lors de l'interprétation des données."
  }
})

export default function WidgetErrorFallback(props) {
  const { type } = props
  const { formatMessage: format } = useIntl()
  return (
    <Container maxWidth="lg">
      <Alert severity="error">
        <AlertTitle>
          {format(errorMessage.title, {
            type
          })}
        </AlertTitle>
        {format(errorMessage.info)}
      </Alert>
    </Container>
  )
}

WidgetErrorFallback.propTypes = {
  type: PropTypes.string.isRequired
}
